import ContentAdminEditor from "content/adminEditors/ContentAdminEditor";


import FieldEditor from "editor/FieldEditor";
class ContentAdminEditorFiles extends ContentAdminEditor {

    static get_name() {
        return 'Files';
    }

    getInputType() {
        return '9';
    }

    /**
     * @abstract
     * @return Array
     */
    getSettingsOptions() {
        return [
            {
                name: 'slug',
                label: 'Slug',
                type: 'text'
            },
            {
                label: 'Options',
                type: 'group',
                children: [
                    {
                        name: 'multiple',
                        label: 'Allow more than one',
                        type: 'checkbox',
                        default: true
                    }
                ]
            },
            {
                name: 'extensions',
                label: 'Allowed Extensions (comma separated)',
                type: 'text'
            }
        ];
    }
}

FieldEditor.register_editor('content/admin/files', ContentAdminEditorFiles);

export default ContentAdminEditorFiles;
